export default __webpack_public_path__ + "static/media/the-gluten-free-factory.5378aee8.svg";